import { useSyncExternalStore } from "react";
import { useWatch } from "react-hook-form";
import SaveButton from "@/components/SaveButton";
import { RowSelectionStore } from "@/components/data-table/context/RowSelectionContext";

interface StoreProjectAssigneesCreatorSaveButtonProps {
  storesStore: RowSelectionStore;
}

export const StoreProjectAssigneesCreatorSaveButton = ({
  storesStore,
}: StoreProjectAssigneesCreatorSaveButtonProps) => {
  const projectId = useWatch({ name: "project_id" });
  const userId = useWatch({ name: "user_id" });
  const storesCount = useSyncExternalStore(
    storesStore.subscribe,
    storesStore.getSelectionCount,
  );

  const canSubmit =
    Boolean(projectId?.trim()) && Boolean(userId?.trim()) && storesCount > 0;

  return <SaveButton disabled={!canSubmit} />;
};
